import React from "react";
import FormHelperText from "components/Form/components/FormHelperText";
import FormSubtext from "components/Form/components/FormSubtext";
import "./style.scss";

const Currency = ({
  id,
  classes,
  name,
  label,
  error,
  register,
  ...inputProps
}) => {
  const currency = inputProps?.currency ?? "";
  return (
    <div className="currency-input">
      <label htmlFor={id}>{label}</label>
      {inputProps.subtext && <FormSubtext text={inputProps.subtext} />}
      <div className="input-group-addon">
        {/* <div className="input-group-addon__addon">{currency}</div> */}
        <input
          {...register(name)}
          id={id}
          type="number"
          className={`input-text --regular ${classes ?? ""} ${
            currency ? "has-symbol" : ""
          }`}
          required={inputProps.required}
          defaultValue={inputProps.defaultValue}
          placeholder={inputProps.placeholder}
          data-test="currency-input"
        />
        <div className="input-group-addon__addon">.00</div>
      </div>
      {error && <FormHelperText message={error.message} />}
    </div>
  );
};

export default Currency;
